import { Producer } from "Models/producer";
import { ACTION, SetProducersAction, SET_PRODUCER } from "Redux/actionTypes";

const initialState = new Producer();

export default function reduce(state: Producer = initialState, action: ACTION) {
    switch (action.type) {
        case SET_PRODUCER: {
            const {
                payload: { producer },
            } = action as SetProducersAction;
            return { ...state, ...producer };
        }
        default:
            return state;
    }
}
